import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence, delay } from "framer-motion";
import "./detail.scss";
// import PartOne from "./partOne/PartOne";
// import PartTwo from "./partTwo/PartTwo";
// import PartThree from "./partThree/PartThree";
// import PartFour from "./partFour/PartFour";
// import PartFive from "./partFive/PartFive";
import Header from "../../components/header/Header";
import { message } from "antd";
import { zipImages } from "../../untils/until";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import ScreenTip from "../../components/home-screen-tip/ScreenTip"

// 5个页面的配置数据

const IpDetail = () => {
  // const [[currentPage, direction], setPage] = useState([0, 0]); // [当前页码, 方向(1前进/-1后退)]
  const [activeTab, setActiveTab] = useState("part-1"); // 新增状态来跟踪当前活动的标签页
  // const [currentPage, setCurrentPage] = useState(0);
  const [currentIp, setCurrentIp] = useState(0);
  const [direction, setDirection] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const containerRef = useRef(null);
  const isSwitching = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpne] = useState(false);
    const [mobile, setMobile] = useState(false);

  const {i18n} = useTranslation();
  console.log(i18n.language)
  const ipDetailList = [
  {
    id: 1,
    title: i18n.t("detail_qhc_title"),
    subTitle: "QING HUA QI YUN",
    description:
      i18n.t("detail_qhc_content"),
    textBgColor: "#7A99C7",
    bgColor: "#D2E5F5",
    bg: `url(${zipImages(
      "https://oss.tnworld.cn/eastern/assets/qhc/qhc-detail-bg.jpg"
    )})`,
    poster: zipImages(
      "https://oss.tnworld.cn/eastern/assets/qhc/qhc-poster.jpg"
    ),
  },
  {
    id: 2,
    title: i18n.t("detail_zgj_title"),
    subTitle: "JI JIE FU YUN",
    description:
      i18n.t("detail_zgj_content"),
    textBgColor: "#992322",
    bgColor: "#FDFBED",
    bg: `url(${zipImages(
      "https://oss.tnworld.cn/eastern/assets/zgj/zgj-bg.jpg"
    )})`,
    poster: zipImages(
      "https://oss.tnworld.cn/eastern/assets/zgj/zgj-poster.jpg"
    ),
    
  },
  {
    id: 3,
     title: i18n.t("detail_cjy_title"),
    subTitle: "FENG HUA SHENG YONG",
    description:
      i18n.t("detail_cjy_content"),
    textBgColor: "#C8964E",
    bgColor: "#413A29",
    bg: `url(${zipImages(
      "https://oss.tnworld.cn/eastern/assets/cjy/cjy-detail-bg.jpg"
    )})`,
    poster: zipImages(
      "https://oss.tnworld.cn/eastern/assets/cjy/cjy-poster.jpg"
    ),
   
  },
  {
    id: 4,
    title: i18n.t("detail_jtl_title"),
    subTitle: "HUA KAI JING TAI",
    description:
      i18n.t("detail_jtl_content"),
    textBgColor: "#004CA0",
    bgColor: "#00A1CB",
    bg: `url(${zipImages(
      "https://oss.tnworld.cn/eastern/assets/jtl/jtl-detail-bg.jpg"
    )})`,
    poster: zipImages(
      "https://oss.tnworld.cn/eastern/assets/jtl/jtl-poster.jpg"
    ),
  },
];


  const hideModal = () => {
    setOpne(false);
  };

  // 动画配置
  const variants: any = {
    enter: (direction: any) => ({
      opacity: 0,
      transition: { duration: 0.3 },
    }),
    center: {
      opacity: 1,
      transition: { duration: 2 },
    },
    exit: (direction: any) => ({
      opacity: 0, // 退出时停留在 50% 透明度
      transition: {
        duration: 1,
        // delay: direction > 0 ? 0 : 0.25 // 方向不同时延迟不同
      },
    }),
  };

  const variants2: any = {
    enter: (direction: any) => ({
      opacity: 0,
      transition: { duration: 0.3 },
    }),
    center: {
      opacity: 1,
      transition: { duration: 1 },
    },
    exit: (direction: any) => ({
      opacity: 0, // 退出时停留在 50% 透明度
      transition: {
        duration: 1,
        // delay: direction > 0 ? 0 : 0.25 // 方向不同时延迟不同
      },
    }),
  };

  const switchIp = (id: number) => {
    setCurrentIp(id);
  };

  const handleNavClick = (type: string, ip: number) => {
    switch (type) {
      case "home":
        navigate("/", { replace: true });
        break;
      case "verse":
        // window.open(`https://${ip}`, "_blank");
        if (ip === -1) {
          navigate("/", { replace: true, state: { page: 1 } });
        } else {
          switch (ip) {
            case 0:
              navigate("/scene?scene=qinghuaci")
              break;
            case 1:
              navigate("/scene?scene=zhongguojie")
              break;
            case 2:
              navigate("/scene?scene=cuojinyin")
              break;
            case 3:
              navigate("/scene?scene=jingtailan")
              break;
            default:
              message.warning("敬请期待");
              break;
          }
        }
        break;
      case "detail":
        if (ip === -1) {
          setCurrentIp(0);
        } else {
          setCurrentIp(ip);
        }
        break;
      case "about":
        // message.success("跳转中国工艺");
        navigate("/about");
        break;
    }
  };

  useEffect(() => {
    // 从location.state中获取page参数
    const ip = location.state?.ip;

    if (ip) {
      setCurrentIp(ip);
    } else {
      setCurrentIp(0);
    }
  }, [location.state]); // 依赖location.state变化

    useEffect(() => {
      setMobile(typeof window.orientation !== "undefined" ||
        navigator.userAgent.indexOf("IEMobile") !== -1 ||
        navigator.userAgent.indexOf("iPhone") !== -1 ||
        (navigator.userAgent.indexOf("Android") !== -1 &&
          navigator.userAgent.indexOf("Mobile") !== -1) ||
        navigator.userAgent.indexOf("BlackBerry") !== -1 ||
        navigator.userAgent.indexOf("Opera Mini") !== -1);
    }, [])

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Header onNavClick={handleNavClick} activeTab={activeTab} />{" "}
      {/* 将活跃标签页传递给Header */}
            {mobile && <ScreenTip />}
      {/* 页面容器 */}
      <AnimatePresence mode={"popLayout"} custom={direction} initial={true}>
        <div className="page-container">
          <motion.div
            key={ipDetailList[currentIp].id}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            className="page-container-bg"
            style={{
              backgroundImage: ipDetailList[currentIp].bg,
            }}
          ></motion.div>
          <div className="detail-wrapper">
            <motion.div
              key={ipDetailList[currentIp].id}
              custom={direction}
              variants={variants2}
              initial="enter"
              animate="center"
              exit="exit"
              className="detail-bg"
              style={{ backgroundColor: ipDetailList[currentIp].bgColor }}
            >
              <img src="https://oss.tnworld.cn/eastern/assets/paper.webp" className="paper" alt="" />
            </motion.div>
            <div className="detail-content">
              <div className="left-list">
                {ipDetailList.map((item, index) => (
                  <div
                    key={index}
                    className={
                      currentIp === index ? "left-item focused" : "left-item"
                    }
                    onClick={() => switchIp(index)}
                  >
                    <img src={item.poster} alt={item.title} />
                    <div className="indicator"></div>
                  </div>
                ))}
              </div>
              <motion.div
                key={ipDetailList[currentIp].title}
                custom={direction}
                variants={variants2}
                initial="enter"
                animate="center"
                exit="exit"
                className="center-poster"
              >
                <img
                  src={ipDetailList[currentIp].poster}
                  alt={ipDetailList[currentIp].title}
                />
              </motion.div>
              <motion.div
                key={ipDetailList[currentIp].subTitle}
                custom={direction}
                variants={variants2}
                initial="enter"
                animate="center"
                exit="exit"
                className="description-box"
                style={{ backgroundColor: ipDetailList[currentIp].textBgColor }}
              >
                <img
                  className="box-border"
                  src={zipImages(
                    "https://oss.tnworld.cn/eastern/assets/detail-border.png"
                  )}
                  alt=""
                />
                <div className="description-content">
                  <div className="title" style={
                    i18n.language === 'en'? {
                      fontSize: '2rem'
                    }:{}
                  }>{ipDetailList[currentIp].title}</div>
                  <div className="sub-title">
                    {ipDetailList[currentIp].subTitle}
                  </div>
                  <div className="introduction" style={
                    i18n.language === 'en'? {
                      fontSize: '0.9rem',
                      textAlign: 'left'
                    }:{}
                  }>
                    {ipDetailList[currentIp].description}
                  </div>
                  <div
                    onClick={() => setOpne(true)}
                    className="btn"
                    style={
                      i18n.language === 'en'? {
                        fontSize: '0.9rem',
                        textAlign: 'left',
                        paddingLeft: "3%",
                        backgroundImage: `url(${zipImages(
                        "https://oss.tnworld.cn/eastern/assets/btn-bg.png"
                      )})`,
                      }:{
                        backgroundImage: `url(${zipImages(
                        "https://oss.tnworld.cn/eastern/assets/btn-bg.png"
                      )})`,
                      }
                    }
                  >
                    {i18n.t("detail_contact")}
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </AnimatePresence>
     {open && <div className="modal-box" >
        <div className="modal-content">
          <div style={{ color: 'black', fontSize: '16px', marginTop: '10px' }}>{i18n.t('contact_title')}<br/><br/>{i18n.t('contact_phone')}010-85698338<br/><br/>{i18n.t('contact_email')}huangshy@polycac.com.cn</div>
          <div className="foot-btn">
            <div onClick={hideModal}>
              {i18n.t('contact_btn')}
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
};

export default IpDetail;
